import { useLinkedinInfo } from "../../../hooks/useLinkedinInfo";
import { AccountStatus, WhoAmIUserData } from "../../../hooks/useWhoAmI";
import { formatProfileData } from "../../../lib/utils/profile-formatter";

interface UserData {
	name: string;
	phone: string;
	linkedinUrl: string;
	linkedinData: any;
	linkedApiData?: string | null;
}

interface UseAgentPageReturn {
	linkedinLoading: boolean;
	linkedinUserData: any;
	userData: UserData | null;
	hasLinkedinData: boolean; // Flag to check if raw LinkedIn data exists
}



export function useAgentPage(userData: WhoAmIUserData | null | undefined, isLoading: boolean): UseAgentPageReturn {

	const { linkedinData: linkedinUserData, loading: linkedinLoading } = useLinkedinInfo(
		true,
		userData?.account_status === AccountStatus.ACTIVE && !isLoading
	);


	// Extract the profile data array from linkedinUserData
	const linkedinProfileData = linkedinUserData?.relivance_profile_data?.[0]?.Value;
	const formattedProfileData = formatProfileData(linkedinProfileData);
	const formattedLinkedinProfileData = {
		profilePictureUrl: linkedinUserData?.user?.profile_picture_url || "",
		userName: userData?.full_name || linkedinUserData?.user?.full_name || "Guest",
		firstName: (userData?.full_name || linkedinUserData?.user?.full_name || "Guest").split(" ")[0],
		experience: formattedProfileData?.experiences || [],
		headline: formattedProfileData?.headline || linkedinUserData?.headline || "",
		summary: formattedProfileData?.about || formattedProfileData?.summary || "",
		location: formattedProfileData?.location || "",
		education: formattedProfileData?.educations || [],
		currentRole: formattedProfileData?.job_title || "",
		currentCompany: formattedProfileData?.current_company || formattedProfileData?.company || "",
		summaryPreview: (formattedProfileData?.about || formattedProfileData?.summary || "") 
			? (formattedProfileData?.about || formattedProfileData?.summary || "").split(" ").slice(0, 15).join(" ") + "..." 
			: "",
	};

	// Create UserData object matching agent-avatar interface
	const userDataObject: UserData | null = linkedinUserData ? {
		name: userData?.full_name || linkedinUserData?.user?.full_name || "Guest",
		phone: userData?.phone_number || "",
		linkedinUrl: linkedinUserData?.linkedin_url || "",
		linkedinData: formattedProfileData || null,
		linkedApiData: linkedinUserData ? JSON.stringify(linkedinUserData) : null,
	} : null;

	return {
		linkedinLoading,
		linkedinUserData: formattedLinkedinProfileData,
		userData: userDataObject,
		hasLinkedinData: !!linkedinUserData, // Check if raw LinkedIn data exists
	};
}
